import {
  Column,
  CreateDateColumn,
  Index,
  PrimaryGeneratedColumn,
} from 'typeorm';

import { ApiProperty } from '../../codegen';
import { EPartners } from '../../enums';
import { IsDate, IsEnum, IsNumber } from '../../validators';

@Index(['userId', 'createdAt'], {
  unique: true,
})
export class LoginHistory {
  @ApiProperty()
  @IsNumber({}, { groups: ['error'] })
  @PrimaryGeneratedColumn()
  id: number;

  @IsDate()
  @CreateDateColumn({ type: 'timestamptz', precision: 3 })
  createdAt!: Date;

  @Column({ type: 'varchar', enum: EPartners, nullable: true })
  @IsEnum(EPartners, { groups: ['error'] })
  partner: EPartners;

  @Column({ type: 'int', nullable: false, default: 0 })
  @IsNumber({}, { groups: ['error'] })
  userId: number;
}
